<template>
  <el-dialog
    title="选择海报背景模版"
    :visible.sync="dialogVisible"
    width="960px"
    @close="handleClose"
  >
    <el-radio-group v-model="temp">
      <div class="tempList">
          <template v-for="(item,index) in tempList">
            <div class="tempItem" :key="index" >
              <img class="tempItemImg" :src="item.img" />
              <el-radio :label="item.value">{{item.name}}</el-radio>
            </div>
          </template>
      </div>
    </el-radio-group>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="save">应 用</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryDmsCompanyInfo,isToExamine } from '@/api/supplier/index'
export default {
  data() {
    return {
      tempList:[
        {
          name:'默认背景',
          img:'https://erp-qd.oss-cn-hangzhou.aliyuncs.com/erp-kmt/kmt-pc/defaultPosterTemp.png',
          value:'1'
        },
        {
          name:'年货节',
          img:'https://erp-qd.oss-cn-hangzhou.aliyuncs.com/erp-kmt/kmt-pc/newYearsGoodsFestivalTemp.png',
          value:'2'
        },
      ],
      dialogVisible: false,
      temp:'1',
      companyInfo:{},
    };
  },
  components: {},
  created(){
    this.getDmsCompanyInfo();
  },
  methods: {
    save(){
      isToExamine({
        needAudit:this.companyInfo.needAudit,
        needStaff:this.companyInfo.needStaff,
        posterBgTemplate:this.temp
      }).then(res => {
        if(res.result === 1){
          this.$message.success('保存成功');
          this.$emit('changePosterTemplat',this.temp);
          this.handleClose();
        }else{
           this.$message.console.error(res.message || '保存失败！');;
        }
      });
    },
    openDialog(params){
        this.dialogVisible = true;
    },
    async getDmsCompanyInfo(){
      let res = await queryDmsCompanyInfo();
      if(res.result === 1){
         this.companyInfo = {
           ...res.data
         }
         this.temp = res.data.posterBgTemplate || '1';
      }
    },
    handleClose(){
        this.dialogVisible = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.tempList{
  display: flex;
  .tempItem{
    width: 216px;
    height: 466px;
    text-align: center;
    padding: 8px;
    border: 1px solid #DFE2E8;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .tempItem + .tempItem{
    margin-left: 16px;
  }
  .tempItemImg{
    height: 422px;
    margin-bottom: 10px;
    border-radius: 4px;
  }
}
</style>
